import React from 'react';
import { Grid, Divider, Box, CircularProgress } from '@material-ui/core';
import { OrangeButton, PrimaryButton } from 'components/Button';

import { IntlShape, injectIntl } from 'react-intl';
import messages from 'containers/SignupPages/ActionsButtons/messages';

import { translate } from 'helpers/intl';
import GATracking, { EVENT_ACTION } from 'helpers/GATracking';

export type ActionsButtonsType = {
  isLoading?: boolean;
  onClickNext?: Function;
  onClickPrevious?: Function;
  disableNext?: boolean;
  previousLabel?: string;
  nextLabel?: string;
  gridXs?: any;
  gridNextButton?: any;
  intl: IntlShape;
  nextGACategory?: string;
  nextGALabel?: string;
  previousGACategory?: string;
  previousGALabel?: string;
};
const ActionsButtons = ({
  isLoading,
  onClickNext,
  onClickPrevious,
  disableNext,
  previousLabel,
  nextLabel,
  gridXs,
  gridNextButton,
  nextGACategory,
  nextGALabel = 'Suivant',
  previousGACategory,
  previousGALabel = 'Précedant',
  ...props
}: ActionsButtonsType) => {
  return (
    <React.Fragment>
      <Divider />
      <Box px={[2, 4, 4]} py={3}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid xs={gridXs || 3} item>
            <PrimaryButton
              onClick={() => {
                if (onClickPrevious) {
                  onClickPrevious();
                }
                if (previousGACategory) {
                  GATracking.event(
                    previousGACategory,
                    EVENT_ACTION.CLICK,
                    previousGALabel,
                  );
                }
              }}
              disabled={!onClickPrevious}
            >
              {previousLabel || translate({ ...messages.precedent }, props)}
            </PrimaryButton>
          </Grid>
          <Grid xs={gridNextButton || 3} item>
            <OrangeButton
              variant="contained"
              type="submit"
              onClick={() => {
                if (onClickNext) {
                  onClickNext();
                }
                if (nextGACategory) {
                  GATracking.event(
                    nextGACategory,
                    EVENT_ACTION.CLICK,
                    nextGALabel,
                  );
                }
              }}
              disabled={disableNext}
            >
              {isLoading ? (
                <CircularProgress data-testid="loader" size={20} />
              ) : (
                <React.Fragment>
                  {nextLabel || translate({ ...messages.suivant }, props)}
                </React.Fragment>
              )}
            </OrangeButton>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
};

export default injectIntl(ActionsButtons);
